export default "__VITE_ASSET__CPaVlwK$__"